import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Switch, Checkbox, Select, Button, Spin } from "antd";

const NotificationTopicDrawer = ({
  visible,
  onClose,
  onSubmit,
  topic,
  roles,
  users,
  loading
}) => {
  const [form] = Form.useForm();
  const selectedChannels = Form.useWatch("channels", form) || [];
  const [initialChannels, setInitialChannels] = useState([]);

  // populate form if editing
  useEffect(() => {
    if (topic) {
      const channelTypes = topic.channels?.map((c) => c.type);

      setInitialChannels(topic.channels || []);

      const channelDescriptions = {};
      topic.channels?.forEach((c) => {
        channelDescriptions[c.type] = c.description;
      });

      form.setFieldsValue({
        ...topic,
        channels: channelTypes,
        channelDescriptions,
      });
    } else {
      form.resetFields();
      setInitialChannels([]);
    }
  }, [topic]);

  const handleFinish = async (values) => {
    try {
      const payload = {
        name: values.name,
        description: values.description,
        isEnabled: values.enabled,
        channels: (values.channels || []).map((ch) => ({
          type: ch,
          description: values.channelDescriptions?.[ch] || "",
        })),
        initialChannels,
      };

      onSubmit(payload);
      form.resetFields();
    } catch (error) {
      
    }
  };

  return (
    <Drawer
      title={
        <span style={{ fontFamily: "Inter" }}>
          {topic ? "Edit Notification Topic" : "Create Notification Topic"}
        </span>
      }
      size={520}
      zIndex={99999}
      onClose={onClose}
      open={visible}
      styles={{ body: { paddingBottom: 80 } }}
      footer={
        <div style={{ textAlign: "right" }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => form.submit()}>
            Submit
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        <Form layout="vertical" form={form} onFinish={handleFinish}>
          <Form.Item
            label="Topic Name"
            name="name"
            rules={[
              {
                required: true,
                pattern: /^[A-Z0-9_]+$/,
                message:
                  "Topic name can only contain uppercase letters, numbers, and underscores",
              },
            ]}
          >
            <Input
              placeholder="Enter topic name in format PM_TASK_ACTIVITY"
              onChange={(e) => {
                const formatted = e.target.value
                  .toUpperCase()
                  .replace(/\s+/g, "_");
                form.setFieldsValue({ name: formatted });
              }}
            />
          </Form.Item>

          <Form.Item label="Description" name="description">
            <Input.TextArea placeholder="Enter description" />
          </Form.Item>

          <Form.Item label="Enabled" name="enabled" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item
            label="Channels"
            name="channels"
            rules={[{ required: true, message: "Select at least one channel" }]}
          >
            {/* <Checkbox.Group options={["Email", "SMS"]} /> */}
            <Checkbox.Group
              options={[
                { label: "Email", value: "EMAIL" },
                { label: "SMS", value: "SMS" },
              ]}
            />
          </Form.Item>

          {selectedChannels.map((channel) => (
            <Form.Item
              key={channel}
              label={`${channel} Description`}
              name={["channelDescriptions", channel]}
              rules={[
                { required: true, message: `Enter description for ${channel}` },
              ]}
            >
              <Input placeholder={`Enter ${channel} description`} />
            </Form.Item>
          ))}

          {!topic && (
            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: 4,
                padding: 12,
                background: "#fafafa",
              }}
            >
              <p className="mb-0 pb-0">
                <strong>Note: </strong>Roles & users will be assigned after
                topic creation
              </p>
            </div>
          )}
        </Form>
      </Spin>
    </Drawer>
  );
};

export default NotificationTopicDrawer;
